import styles from '../ccf-consumer-card-notes-tab.module.scss';
import {
  CcfBox,
  CcfCalendarIcon,
  CcfDeboucedInput,
  CcfPlusIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { makeStyles } from '@mui/styles';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getAppSpaceRatio } from '../../../../global.app.slice';
import CcfInteractionsFilterPopover from '../../ccf-consumer-card-interactions-tab/ccf-interactions-filter-popover/ccf-interactions-filter-popover';
/* eslint-disable-next-line */
export interface CcfNotesTabHeaderProps {
  notesViewSelectHandler: (view: string) => void;
  searchHandler: (searchQuery: string) => void;
  handlePopoverOpen: any;
  handlePopoverClose: any;
  handleFilter: any;
  selectedFilterOption: any;
}

const useStyles = makeStyles({
  searchInput: {
    '& .MuiOutlinedInput-root': {
      height: '35px', // Set your desired height here
    },
  },
});

/**@example */
export function CcfNotesTabHeader(props: CcfNotesTabHeaderProps) {
  const classes = useStyles();
  const {
    searchHandler,
    handlePopoverOpen,
    handleFilter,
    selectedFilterOption,
  } = props;
  const [notesMinView, setNotesMinView] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilterAnchorEl, setDateFilterAnchorEl] =
    useState<HTMLElement | null>(null);
  const appSpaceRatio = useSelector(getAppSpaceRatio);
  const [translate] = useTranslator();

  useEffect(() => {
    const isMinView = appSpaceRatio && appSpaceRatio <= 40;
    setNotesMinView(isMinView);
  }, [appSpaceRatio]);

  const containerStyle = useMemo(
    () => ({
      width: notesMinView ? '50%' : '35%',
    }),
    [notesMinView]
  );

  /**
   * Function to select interaction view
   * @example handleSearch()
   */
  const handleSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const query = event.target.value.toLowerCase();
      setSearchQuery(query);
      searchHandler(query);
    },
    [searchHandler]
  );

  /**
   * Function to open the filter popover
   * @example handlePopoverOpen()
   */
  const handleDateFilterPopoverOpen = (event: any) => {
    setDateFilterAnchorEl(event.currentTarget);
  };

  /**
   * Function to close the filter popover
   * @example handlePopoverClose()
   */
  const handleDateFilterPopoverClose = () => {
    setDateFilterAnchorEl(null);
  };

  return (
    <div>
      <CcfBox className={styles.headercontainer}>
        <CcfBox style={containerStyle}>
          <CcfDeboucedInput
            size="small"
            style={{
              background: 'white',
            }}
            value={searchQuery}
            onChange={handleSearch}
            className={classes.searchInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search htmlColor="grey" />
                </InputAdornment>
              ),
            }}
            placeholder={translate('search') + '...'}
            variant="outlined"
            fullWidth
            delay={1500}
          />
        </CcfBox>
        <CcfBox className={styles.btnContainer}>
          <IconButton
            onClick={(e: any) => {
              handlePopoverOpen(e);
            }}
            style={{ pointerEvents: 'auto' }}
          >
            <CcfPlusIcon className={styles.btnIcon} />{' '}
          </IconButton>
          <IconButton style={{ pointerEvents: 'auto' }}>
            <CcfCalendarIcon
              onClick={(e: any) => handleDateFilterPopoverOpen(e)}
              className={styles.btnIcon}
            />{' '}
          </IconButton>
        </CcfBox>
      </CcfBox>
      <CcfInteractionsFilterPopover
        anchorEl={dateFilterAnchorEl}
        handlePopoverClose={handleDateFilterPopoverClose}
        handleFilter={handleFilter}
        selectedFilterOption={selectedFilterOption}
      />
    </div>
  );
}

export default CcfNotesTabHeader;
